import { Component } from "@angular/core";

@Component({
    selector: "app-permission-denied",
    templateUrl: "./permission-denied.component.html",
    styleUrls: ["./permission-denied.component.css"],
})
export class PermissionDeniedComponent {}
